import React, { HTMLProps } from 'react';
import { useTranslation } from 'next-i18next';
import useProductShippingQuery from '@hooks/product/use-product-shipping-query';
import useProductQuery from '@hooks/product/use-product-query';
import sanitizer from '@helpers/sanitizer';
import clsx from 'clsx';
import styles from './shipping-restriction.module.scss';

type ShippingRestrictionProps = Pick<HTMLProps<HTMLDivElement>, 'className'>;

const ShippingRestriction: React.FC<ShippingRestrictionProps> = ({ className }) => {
  const { t } = useTranslation();
  const { productShipping } = useProductShippingQuery();
  const { userTransactionRole } = useProductQuery();
  const isSeller: boolean = userTransactionRole === 'seller';
  const shouldShowCovidShippingMessage: boolean =
    !isSeller && productShipping?.prohibited && productShipping?.prohibitedReason === 'covid';

  if (isSeller || !productShipping?.prohibited) {
    return null;
  }

  return (
    <div
      className={clsx(
        styles.shippingRestriction,
        shouldShowCovidShippingMessage && styles['shippingRestriction--covid'],
        className,
      )}
    >
      {shouldShowCovidShippingMessage ? (
        <span>
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizer(t('PRODUCT.DETAILS.PROHIBITED_MESSAGE_COVID')),
            }}
          />
          <a
            className={clsx(styles.shippingRestriction__link, 'vc-link')}
            target="_blank"
            href="/journal/covid-19-our-faqs/"
            rel="noopener"
          >
            {t('PRODUCT.DETAILS.PROHIBITED_MESSAGE_LINK.TEXT')}
          </a>
        </span>
      ) : (
        <span>{t('PRODUCT.DETAILS.PROHIBITED_MESSAGE')}</span>
      )}
    </div>
  );
};

export default ShippingRestriction;
